import {AppbarElement} from "../../model/appbar-element";

export const APPBAR_ELEMENTS: AppbarElement[] = [
    {
        id: 'recherche',
        authorized: [
            {role: 'administrateur', statut: 'cotisant'},
            {role: 'administrateur', statut: 'payant'},
            {role: 'gestionnaire', statut: 'cotisant'},
            {role: 'gestionnaire', statut: 'payant'},
            {role: 'formateur', statut: 'cotisant'},
            {role: 'formateur', statut: 'payant'},
            {role: 'contributeur', statut: 'cotisant'},
            {role: 'contributeur', statut: 'payant'},
        ]
    },
    {
        id: 'notifications',
        authorized: [
            {role: 'administrateur', statut: 'cotisant'},
            {role: 'administrateur', statut: 'payant'},
            {role: 'gestionnaire', statut: 'cotisant'},
            {role: 'gestionnaire', statut: 'payant'},
            {role: 'formateur', statut: 'cotisant'},
            {role: 'formateur', statut: 'payant'},
            {role: 'contributeur', statut: 'cotisant'},
            {role: 'contributeur', statut: 'payant'},
            {role: 'apprenant', statut: 'payant'},
        ]
    },
    {
        id: 'messages',
        authorized: [
            {role: 'administrateur', statut: 'cotisant'},
            {role: 'administrateur', statut: 'payant'},
            {role: 'gestionnaire', statut: 'cotisant'},
            {role: 'gestionnaire', statut: 'payant'},
            {role: 'formateur', statut: 'cotisant'},
            {role: 'formateur', statut: 'payant'},
            {role: 'contributeur', statut: 'cotisant'},
            {role: 'contributeur', statut: 'payant'},
        ]
    },
    {
        id: 'mon-compte',
        authorized: [
            {role: 'administrateur'},
            {role: 'gestionnaire'},
            {role: 'formateur'},
            {role: 'contributeur'},
            {role: 'apprenant'},
            {role: 'candidat'},
        ]
    },
    {
        id: 'connexion',
        authorized: [
            {role: 'visiteur'}
        ]
    }
];
